import { useContext, useEffect, useState } from "react";
import { FaPlay, FaStop } from "react-icons/fa";
import UserContext from "../../User/UserContext";
import { GiAlarmClock } from "react-icons/gi";
import { getADPFormattedTimestamp } from "../ClockinUtils";
import LoadingCircle from "../../utility/LoadingCircle";

export default function BreakBar({ api, token }) {
	const [isLoading, setIsLoading] = useState(false);
	const { startTime, setStartTime } = useContext(UserContext);
	const [secondsElapsed, setSecondsElapsed] = useState(0);
	const [twoHourHit, setTwoHourHit] = useState(false);
	useEffect(() => {
		if (!startTime) {
			setSecondsElapsed(0);
			setTwoHourHit(false);
			return;
		}

		const startMs = new Date(startTime).getTime();
		let handle;

		const tick = () => {
			const diffSec = Math.floor((Date.now() - startMs) / 1000);
			setSecondsElapsed(diffSec);

			if (diffSec >= 7200) {
				setTwoHourHit(true);
				clearInterval(handle);
			}
		};

		handle = setInterval(tick, 1000);
		tick();

		return () => clearInterval(handle);
	}, [startTime]);

	useEffect(() => {
		if (twoHourHit) {
			fetch(api + "/clocking/break", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
				},
				body: JSON.stringify({
					startTime,
					hit2HourLimit: true,
					endTime: new Date(),
					ADPTimestamp: getADPFormattedTimestamp(),
				}),
			}).then((res) => {
				if (res.ok) {
					setTwoHourHit(false);
					setStartTime(null);
				}
			});
		}
	}, [api, setStartTime, startTime, token, twoHourHit]);

	const formatDuration = (totalSec) => {
		const days = Math.floor(totalSec / 86400);
		const hrs = Math.floor((totalSec % 86400) / 3600);
		const mins = Math.floor((totalSec % 3600) / 60);
		const secs = totalSec % 60;
		return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
	};

	const startBreak = (e) => {
		e.preventDefault();
		const newDate = new Date();
		if (startTime) {
			alert("You are already on break");
		} else {
			setStartTime(newDate);
		}
	};

	const endBreak = (e) => {
		e.preventDefault();
		setIsLoading(true);
		fetch(api + "/clocking/break", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + token,
			},
			body: JSON.stringify({
				startTime,
				hit2HourLimit: false,
				endTime: new Date(),
				ADPTimestamp: getADPFormattedTimestamp(),
			}),
		}).then((res) => {
			setIsLoading(false);
			if (res.ok) {
				setTwoHourHit(false);
				setStartTime(null);
			} else {
				alert("An error occurred");
			}
		});
	};

	return (
		<div className="bg-zinc-200 p-2 flex flex-col md:flex-row justify-between items-center ">
			<div className="flex items-center gap-1">
				<GiAlarmClock className="text-3xl" />
				<p className="text-2xl font-bold">Break</p>
			</div>
			<div className="flex flex-col md:flex-row gap-1 items-center justify-center w-full md:w-auto">
				{isLoading ? (
					<div className="shadow-lg rounded-full bg-white">
						<LoadingCircle />
					</div>
				) : (
					<>
						{!startTime ? null : (
							<>
								<span>{`(${formatDuration(secondsElapsed)})`}</span>
							</>
						)}
						<button
							onClick={!startTime ? startBreak : null}
							disabled={startTime}
							className={`
						flex items-center gap-2 text-white p-1 px-2 rounded-lg w-full flex justify-center
						${startTime ? "bg-gray-500" : "bg-blue-600 hover:bg-blue-700"}
					`}>
							<FaPlay />
							Start
						</button>

						<button
							className={`${
								startTime ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-500"
							} text-white p-1 px-2 rounded-lg flex items-center gap-2 w-full flex justify-center`}
							disabled={!startTime}
							onClick={startTime ? endBreak : null}>
							<FaStop />
							End
						</button>
					</>
				)}
			</div>
		</div>
	);
}
